'use client';

import { useI18n } from '~/features/i18n';

/**
 * Label for the "Locatie naar keuze" option. The selected city is intentionally not
 * appended because the location is already shown separately where applicable.
 */
export function useCustomLocationLabel(): string {
    const i18n = useI18n();
    return i18n._('pdp.location.dropdown.custom', undefined, {
        message: 'Location of your choice',
    });
}
